/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("pgcAuthenticationModule", [
    "pgcAuthenticationRouter",//路由
    "personalModule",//个人
    "enterpriseModule",//企业
]).
controller("pgcAuthenticationCtrl", ["$scope","$stateParams","$state","localStorageService", function($scope,$stateParams,$state,localStorageService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            choseType:''
        };
        $scope.data = {
            listData: [],
        };
        // $scope.parentParams = localStorageService.get('basicinformation');
        // console.log($scope.parentParams);
        $scope.userType = $stateParams.userType;
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {

    }

    $scope.choseType = function(item){
        $scope.status.choseType = item;
        if(item ==0){
            var orgUrlName = "register.pgcauthentication.personal";
            $state.go(orgUrlName,{type:item,userType:$scope.userType});
        }else{
            var orgUrlName = "register.pgcauthentication.enterprise";
            $state.go(orgUrlName,{type:item,userType:$scope.userType});
        }
    };




}]);